import styled from "styled-components";

export const Container = styled.div`
	cursor: pointer;
	font-size: 20px;
	text-align: center;
	transition: opacity 0.25s, transform 0.25s;
  width: 26px;
`;
